import { render, staticRenderFns } from "./PurchaseViewForm.vue?vue&type=template&id=22d17da6&scoped=true"
import script from "./PurchaseViewForm.vue?vue&type=script&lang=js"
export * from "./PurchaseViewForm.vue?vue&type=script&lang=js"
import style0 from "./PurchaseViewForm.vue?vue&type=style&index=0&id=22d17da6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d17da6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22d17da6')) {
      api.createRecord('22d17da6', component.options)
    } else {
      api.reload('22d17da6', component.options)
    }
    module.hot.accept("./PurchaseViewForm.vue?vue&type=template&id=22d17da6&scoped=true", function () {
      api.rerender('22d17da6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/components/PurchaseViewForm.vue"
export default component.exports